import { z } from "zod";
import { ApprovalSchema } from "../entities";
import { ApprovalStatusSchema } from "../enums";

/** `GET /api/approvals`. */
export const ListApprovalsQuerySchema = z.object({
  status: ApprovalStatusSchema.optional(),
});
export type ListApprovalsQuery = z.infer<typeof ListApprovalsQuerySchema>;

export const ListApprovalsResponseSchema = z.object({
  approvals: z.array(ApprovalSchema),
});
export type ListApprovalsResponse = z.infer<typeof ListApprovalsResponseSchema>;

/**
 * `POST /api/approvals/:id/approve` — the single-use `token` from the push
 * payload authorizes the transition; the DO timeout remains authoritative.
 */
export const ApproveApprovalSchema = z.object({
  token: z.string().min(1),
});
export type ApproveApproval = z.infer<typeof ApproveApprovalSchema>;

/** `POST /api/approvals/:id/reject`. */
export const RejectApprovalSchema = z.object({
  reason: z.string().optional(),
});
export type RejectApproval = z.infer<typeof RejectApprovalSchema>;

/** Approve/reject response. */
export const ApprovalResponseSchema = ApprovalSchema;
export type ApprovalResponse = z.infer<typeof ApprovalResponseSchema>;
